import { useAppSelector } from "JS/Redux/Store";

export const useDisclosurePrefetch = () => {
    const prefetch = useAppSelector((state) => state.disclosure?.prefetch);

    const total = prefetch?.total ?? 0;
    const completed = prefetch?.completed ?? 0;

    return {
        show: total > 0 && completed < total,
        total,
        completed,
        fileName: prefetch?.fileName ?? "",
        percentage: total > 0 ? Math.round((completed / total) * 100) : 0,
    };
};
